import React from "react";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import { Provider as JotaiProvider } from "jotai";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Popup from "@/components/Popup";
import store from "@/store";
import { GG_APP_ID } from "@/AppConstants";

const alertOptions = {
    position: positions.MIDDLE,
    timeout: 1000 * 5000,
    transition: transitions.FADE,
    containerStyle: {
        positions: "fixed",
        top: 0,
        width: 0,
        height: 0,
        zIndex: 1000,
    },
};

const AppProviders = ({ children }) => {
    return (
        <GoogleOAuthProvider clientId={GG_APP_ID}>
            <JotaiProvider store={store}>
                <AlertProvider template={Popup} {...alertOptions}>
                    {children}
                </AlertProvider>
            </JotaiProvider>
        </GoogleOAuthProvider>
    );
};

export default AppProviders;
